
import { iconDictionary } from '~/utils/icon-dictionary'

export default {
  props: {
    // Required
    title: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },

    // Optional
    cta: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      items: [],
    }
  },

  computed: {
    buttonIcon() {
      const iconName = iconDictionary.get(this.cta.icon)

      return iconName ? require(`~/assets/images/${iconName}?inline`) : null
    },

    buttonLink() {
      return this.$getLinkFromDato(this.cta.link)
    },
  },
}
